import { Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { SearchService } from '@services/search/search.service';
import { FiltersSectionComponent } from '../../../components/search/filters-section/filters-section.component';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'tvb-plp-filters-mobile-menu',
  templateUrl: './plp-filters-mobile-menu.component.html',
  styleUrls: ['./plp-filters-mobile-menu.component.scss'],
})
export class PlpFiltersMobileMenuComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Input() totalItemsCount: number;
  @Output() clear: EventEmitter<any> = new EventEmitter();
  @Output() apply: EventEmitter<any> = new EventEmitter();
  @ViewChild(FiltersSectionComponent) filtersSectionComponent: FiltersSectionComponent;

  constructor(
    private renderer: Renderer2,
    private searchService: SearchService,
    @Inject(DOCUMENT) private doc: Document
  ) {}

  ngOnInit(): void {
    this.isVisible = this.searchService.menuMobileOpen.value.open;
  }

  toggle(): void {
    this.isVisible = !this.isVisible;

    if (this.isVisible) {
      this.renderer.addClass(this.doc.body, 'noVerticalScroll');
    }
    else {
      this.renderer.removeClass(this.doc.body, 'noVerticalScroll');
    }
  }

  emitClear(event): void {
    this.clear.emit(true);
    event.preventDefault();
  }

  emitApply(event): void {
    this.apply.emit();
  }

  removeTag(tag: unknown): void {
    this.filtersSectionComponent.removeTag(tag);
  }
}
